<template>
    <div style="position: absolute; top: 0px; left: 0px;">
        <div class="row mx-0 mb-0">

            <img src="../../static/flyerGalery.jpg" alt="../../static/flyerGalery.jpg" style="width: 100%;">
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: black; color: white; display: flex; justify-content: center;">
            <div style="font-size: 16px;" class="py-2">
                ברוכים.ות הבאים.ות לתערוכה
            </div>
            <div style="font-size: 32px; font-weight: 600;" class="py-2">
                פולחן של יום יום
            </div>
            <div style="font-size: 16px;" class="py-2">
                מזמינות אתכן ואתכם ללחוץ על הכפתור התואם למספר בתצוגה ולשמוע על העבודות מפי האמניות:
            </div>
        </div>
        <div class="row p-0 m-0">
            <div v-for="(audio, index) in audioFiles" :key="index" @click="toggleAudio(index)" class="col-4 d-flex px-2 "    >
                <div class="itemSquare mb-2"  :style="{ backgroundColor: isPlaying(index) ? '#f1750a' : '#FFFFFF' }">
                    <div v-if="index == 18" class="row d-flex justify-content-center fw-bold align-items-center " style="height: 70px; font-size: 19px; color: rgb(99, 196, 195);" >
                        לא נמצא
                    </div>
                    <div v-else class="row d-flex justify-content-center" style="color: #63C4C3;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="70px" height="70px" fill="currentColor"
                            class="bi bi-headphones" viewBox="0 0 16 16" style="position: relative; bottom: 2px;">
                            <path
                                d="M8 3a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a6 6 0 1 1 12 0v5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1V8a5 5 0 0 0-5-5" />
                        </svg>
                    </div>
                    <div class="playPause" v-if="index != 18">
                        <!-- <i :class="{'bi bi-play-circle': !isPlaying(index), 'bi bi-pause-circle': isPlaying(index)}"></i>  -->
                        <svg v-if="!isPlaying(index)" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px"
                            fill="currentColor" class="bi bi-play-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path
                                d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                        </svg>
                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor"
                            class="bi bi-pause-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path
                                d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                        </svg>
                    </div>
                    
                    <div class="row d-flex justify-content-center fw-bold soundNumber">
                        {{ index + 1 }}
                    </div>

                </div>
            </div>
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: black; color: white; display: flex; justify-content: center;">
            <div style="font-size: 32px;font-weight: 600;" class="py-2">
                תודה שביקרתם.
            </div>
            <div style="font-size: 16px; " class="py-2">
                למידע על המוזיאון, על תערוכות ואירועים המתקיימים בו במהלך החודש מוזמנים לבקר באתר האינטרנט שלנו ולעקוב אחרינו בפייסבוק ובאינסטגרם </div>
   
            <a :href="museumSite">
                <div class="siteButton mt-2">
                    www.eindormuseum.co.il
                </div>
            </a>

            <div class="row d-flex justify-content-center mt-4" style="color:#63C4C3">
                <!-- <a :href="openWhatsapp">
                    <div class="col-3 links">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                            class="bi bi-whatsapp" viewBox="0 0 16 16">
                            <path
                                d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                        </svg>
                    </div>
                </a> -->
                <a :href="instaPage">
                    <div class="col-4 links">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                            class="bi bi-instagram" viewBox="0 0 16 16">
                            <path
                                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                        </svg>
                    </div>
                </a>
                <a :href="facebookPage">
                    <div class="col-4 links">
                        <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                            class="bi bi-facebook" viewBox="0 0 16 16">
                            <path
                                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                        </svg>
                    </div>
                </a>
            </div>
            <div class="row d-flex justify-content-center mt-4 pt-3" style="border-top: 1px solid white;">
             
                <a :href="visuali">
                    <div class="col-12 linksToWebsite fontPacifico" >
                       designed by Visuali
                    </div>
                </a>
                <a :href="eifoany">
                    <div class="col-12 linksToWebsite" style="font-family: 'segoeui';">
                        developped by Eifoany
                    </div>
                </a>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    data() {
        return {
            eifoany: "https://eifoany.web.app/",
            visuali: "https://www.visuali.co.il/",
            // openWhatsapp: "https://api.whatsapp.com/send?phone=972544233297&text=אשמח להכנס לקבוצת וואטסאפ של המוזאון",
            showPause: false,
            facebookPage: "https://www.facebook.com/eindormuseum",
            instaPage: "https://www.instagram.com/eindormuseum?igsh=aWNwenJ3eWJqNG1p",
            museumSite: " www.eindormuseum.co.il",
            key: "",
            audioFiles: [
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/1%20%D7%9E%D7%99%D7%A8%D7%99%D7%AA%20%D7%94%D7%9C%D7%95%D7%99.mp3?alt=media&token=670b365f-1c1b-434b-b70c-100696852b4b',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/%D7%A6%D7%9C%D7%9E%D7%99%D7%AA%20%D7%90%D7%A9%D7%93%D7%95%D7%93%D7%94%20(%D7%94%D7%A2%D7%AA%D7%A7)2.mp3?alt=media&token=f573cd8a-1c4e-42de-bb17-bdd69a304e4b',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/%D7%91%D7%95%D7%91%D7%95%D7%AA3.mp3?alt=media&token=bd37e84e-813d-400c-9e0d-e6529d1bd0f1',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/4%D7%A7%D7%95%D7%91%D7%99%D7%95%D7%AA.mp3?alt=media&token=32895e23-848b-433a-8b27-6acc66610504',
'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/5%20%D7%93%D7%95%D7%A8%D7%99%D7%AA%20%D7%A4%D7%A8%D7%95%D7%91%D7%99%D7%96%D7%95%D7%A8.mp3?alt=media&token=ff44f3bf-5b85-4006-a5dd-60835d6ccb8f',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/6%20%D7%A9%D7%99%D7%A8%20%D7%96%D7%9C%D7%A6%D7%9E%D7%9F.mp3?alt=media&token=a38d6408-0cb9-4392-b8d7-428f757c5d89',
            'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/7%20%D7%A9%D7%A8%D7%94%20%D7%90%D7%91%D7%A0%D7%99%D7%9F.mp3?alt=media&token=9f553b5b-c482-45ec-9d77-7aa1949948c3',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/8%20%D7%A1%D7%98%D7%A4%D7%A0%D7%99%20%D7%A1%D7%A0%D7%A1%D7%90%D7%95.mp4?alt=media&token=ff788d4b-5540-4656-a5d4-c80772a1a454',
               'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/9%20%D7%90%D7%9C%D7%99%D7%A1%20%D7%A8%D7%97%D7%9E%D7%99%D7%9D.mp3?alt=media&token=ddcc0dbd-d642-48e7-a02c-19277099f04a',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/10%D7%9E%D7%97%D7%91%D7%A6%D7%94.mp3?alt=media&token=d3e8d4ea-82f9-4d7a-9f27-952bc71a7e93',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/11%D7%A6%D7%9C%D7%9E%D7%99%D7%AA%20%D7%90%D7%99%D7%A9%D7%94%20%D7%A0%D7%95%D7%A9%D7%90%D7%AA%20%D7%9E%D7%97%D7%91%D7%A6%D7%94.mp3?alt=media&token=b66aa8d7-ae44-4c1a-9c49-ede077618aa9',
                '',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/13%20%D7%93%D7%9C%D7%99%D7%94%20%D7%97%D7%99%20%D7%90%D7%A7%D7%95.mp4?alt=media&token=66661997-3c13-4a3f-becb-377aabe00cc9',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/13%20%D7%93%D7%9C%D7%99%D7%94%20%D7%97%D7%99%20%D7%90%D7%A7%D7%95.mp4?alt=media&token=66661997-3c13-4a3f-becb-377aabe00cc9',
'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/15%20%D7%99%D7%A2%D7%9C%20%D7%91%D7%A8%20%D7%9C%D7%91.mp3?alt=media&token=847bc5dc-d5a9-40e6-9905-2f61766dc6c7',
'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/16%20%D7%A0%D7%98%D7%A2%20%D7%A7%D7%95%D7%9E%D7%95%D7%A8%D7%A0%D7%99%D7%A7.mp3?alt=media&token=23438e1f-84ff-4ad0-8939-0c348402867a',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/17%20%D7%90%D7%99%D7%A8%D7%99%D7%AA%20%D7%90%D7%91%D7%A8%D7%9E%D7%95%D7%91%D7%99%D7%A5.mp3?alt=media&token=36909ab3-058a-440a-939a-bfaa9d47587e',
'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/18%20%D7%92%D7%9C%20%D7%9E%D7%99%D7%98%D7%A9%D7%9C%20%D7%9E%D7%A7%D7%9C%D7%99%D7%99%D7%9F.mp3?alt=media&token=ef9d6a72-dbb9-4269-b2fe-0dd781373c43',               
                '',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/%D7%A6%D7%9C%D7%9E%D7%99%D7%AA%20%D7%90%D7%99%D7%A9%D7%94%20%D7%9E%D7%AA%D7%95%D7%A4%D7%A4%D7%AA20.mp3?alt=media&token=6a3d3624-6c4a-4a28-8470-bb126a784d94',  
 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/21%20%D7%A0%D7%95%D7%A8%D7%99%D7%AA%20%D7%95%D7%95%D7%9C%D7%A4%D7%94.mp3?alt=media&token=1b299340-9de1-402d-8958-c67c2b098bd6',
    'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/22%20%D7%A4%D7%93%D7%90%D7%A8%D7%98.mp3?alt=media&token=a43ad4ce-db50-436e-911f-e24cf592fca1',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/23%20%D7%A2%D7%A0%D7%91%D7%9C%20%D7%90%D7%9F%20%D7%94%D7%A8%D7%A9%D7%98%D7%99%D7%92.mp3?alt=media&token=a43baab1-25df-4fac-9d06-ddd08844edc3',
                'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/24%20%D7%A2%D7%A0%D7%91%D7%9C%20%D7%90%D7%9F%20%D7%94%D7%A8%D7%A9%D7%98%D7%99%D7%92.mp3?alt=media&token=c2a1a7a6-0515-4175-a45e-a80a9bf4ffe7',
             'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/25%20%D7%A9%D7%A8%D7%95%D7%9F%20%D7%A9%D7%95%D7%A0%D7%A8%D7%99.mp3?alt=media&token=bc4b93ea-2c03-48c4-bdf8-2833591bd2db', 
          'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/26.mp3?alt=media&token=5d498ff0-36d9-4983-9c36-57a192551fe9'
            ],
            audioElements: [],
            currentlyPlayingIndex: null,
        };
    },

    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        error() {
            return this.$store.getters.error;
        },

    },
    methods: {
        isPlaying(index) {
            // console.log("isPlaying")
            // console.log("this.currentlyPlayingIndex", this.currentlyPlayingIndex)
            // console.log("index", index)
            // if (this.currentlyPlayingIndex !== null) {

            // }
            
            // if (this.currentlyPlayingIndex === index) {
            //     console.log("index*********************", index)
            //     if (this.audioElements[index].paused) {
            //         console.log("this.audioElements[index].paused*********************", this.audioElements[index].paused)
            //         return this.currentlyPlayingIndex === null
            //     } else {
            //         console.log("this.audioElements[index].paused*********!!!!!!!!!!************", this.audioElements[index].paused)
            //         return this.currentlyPlayingIndex === index
            //     }
            // } else {
            //     return this.currentlyPlayingIndex === index
            // }

             return this.currentlyPlayingIndex === index 

        },
        toggleAudio(index) {
                        // console.log("index", index)

            // this.isPlaying(index)
            if (this.currentlyPlayingIndex !== null) {
                if (this.currentlyPlayingIndex === index) {
                    // if (this.audioElements[index] && this.audioElements[index].paused) {
                    if (this.audioElements[index].paused) {
                        // console.log("this.audioElements", this.audioElementsֲ[index])
                        this.audioElements[index].play();
                    } else {
                        this.audioElements[index].pause();
                        // console.log("this.audioElements", this.audioElementsֲ[index])
                        // console.log("this.audioElements[index]", this.audioElements[index].parentNode)
                    }
                } else {
                    if (this.audioElements[this.currentlyPlayingIndex]) {
                        this.audioElements[this.currentlyPlayingIndex].pause();
                        this.audioElements[this.currentlyPlayingIndex].currentTime = 0;
                    }
                    this.audioElements[index] = new Audio(this.audioFiles[index]);
                    this.audioElements[index].play();
                    this.currentlyPlayingIndex = index;

                }
            } else {
                this.audioElements[index] = new Audio(this.audioFiles[index]);
                this.audioElements[index].play();
                this.currentlyPlayingIndex = index;
            }
        },
    },

};
</script>

<style scoped>
.links {
    color: white !important;
    text-decoration: none !important
}

.linksToWebsite {
    color: white !important;
    text-decoration: none !important
}

.siteButton {
    background: #63C4C3;
    width: 300px;
    height: 40px;
    font-size: 20px;
    font-family: Heebo;
    border-radius: 3px;
    padding-top: 5px;
    color: white !important;
    text-decoration: none !important
}

.siteButton:active {
    text-decoration: none !important
}


.soundNumber {
    color: black;
    font-size: 27px;
    position: relative;
    bottom: 16px;
}

.playPause {
    position: absolute;
    top: 19px;
    /* left: calc(50% - 10px); */
    right: 48px;
    color: #63C4C3;
}

.presented {
    color: white;
    font-size: 30px;
    font-weight: bold;
    position: relative;
    bottom: 11px;
    text-align: left;
    left: 58px;
}

.itemSquare {
    height: 100px;
    width: 100px;
    border: solid 1px #63C4C3;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 3px #80808026;
    /* background-color: #f1750a; */
}

.titleListName {
    position: absolute;
    top: -45px;
    width: 200px;
    background: white;
    height: 37px;
    z-index: 30;
    margin: 0 auto;
    width: 100%;
    text-align: center;
    padding-top: 5px;
    font-size: 20px;
}

.captionArrow {
    position: absolute;
    font-size: 12px;
    top: 23px;
    left: 30px;
}

.audioButton {
    width: 100%;
    border: 2px #79a541 solid;
    border-radius: 25px;
    height: 40px;
    margin-bottom: 16px;
    position: relative;
}

.titleSpan {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    color: #63C4C3;
    text-align: center;
    font-weight: bold;
}



/* .closingCross {
  position: absolute;
  top: -45px;
  right: 16px;
  z-index: 20;
  color: black;
  font-size: 24px;
  z-index: 50;
} */

.closingCross {
    position: relative;
    top: 0px;
    right: 39px;
    z-index: 20;
    color: black;
    font-size: 16px;
    z-index: 50;
}

.fontHeebo {
    font-family: Heebo;
}

@font-face {
    font-family: Heebo;
    src: url(../../static/Heebo/Heebo-VariableFont_wght.ttf);
}
.fontPacifico {
    font-family: Pacifico;
}

@font-face {
    font-family: Pacifico;
    src: url(../../static/Pacifico/Pacifico-Regular.ttf);
}
</style>
